module.exports = __webpack_public_path__ + "static/flags/PS-60f0bdefb80baf2da27677435fd95eca.gif";